<script setup lang="ts">
import { reactiveOmit } from "@vueuse/core"
import { SearchIcon } from "lucide-vue-next"
import type { ListboxFilterProps } from "reka-ui"
import { useForwardProps } from "reka-ui"
import type { HTMLAttributes } from "vue"

import { useCommand } from "@/components/ui/command"
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "@/components/ui/input-group"

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<
  ListboxFilterProps & {
    class?: HTMLAttributes["class"]
  }
>()

const delegatedProps = reactiveOmit(props, "class")

const forwardedProps = useForwardProps(delegatedProps)

const { filterState } = useCommand()
</script>

<template>
  <div data-slot="command-input-wrapper" class="p-1 pb-0">
    <InputGroup
      class="bg-input/30 border-input/30 h-8! rounded-lg! shadow-none! *:data-[slot=input-group-addon]:pl-2!"
    >
      <InputGroupInput
        v-bind="{ ...forwardedProps, ...$attrs }"
        v-model="filterState.search"
        data-slot="command-input"
        auto-focus
      />
      <!-- <ListboxFilter
        v-bind="{ ...forwardedProps, ...$attrs }"
        v-model="filterState.search"
        data-slot="command-input"
        auto-focus
        :class="
          cn(
            'w-full text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
            props.class,
          )
        "
      /> -->
      <InputGroupAddon>
        <SearchIcon class="size-4 shrink-0 opacity-50" />
      </InputGroupAddon>
    </InputGroup>
  </div>
</template>
